export default "__VITE_ASSET__256cafbc__"